import { Head, router, useForm } from "@inertiajs/react"

import RecordForm from "@/components/record-form"
import RecordPageHeader from "@/components/ui/record-page-header"
import UserForm from "@/components/users/admin-user-form"
import AdminLayout from "@/layouts/admin-layout"
import { adminUsersPath, newAdminUserPath } from "@/routes"
import type { Account, BreadcrumbItem, User } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Users",
    href: adminUsersPath(),
  },
  {
    title: "New User",
    href: newAdminUserPath(),
  },
]

export default function NewUser({
  user,
  accounts,
}: {
  user: User
  accounts: Account[]
}) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      name: user.name,
      email: user.email,
      state: user.state as "active" | "inactive",
      avatar: null as File | null,
      account_uid: user.account_uid,
      send_welcome_email: "1",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(adminUsersPath(), {
      forceFormData: true,
    })
  }

  function handleCancel() {
    router.visit(adminUsersPath())
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />
      <div className="flex h-full w-full flex-col gap-6 p-4">
        <div className="mx-auto w-full max-w-2xl">
          <RecordPageHeader title="New User" />
        </div>
        <RecordForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
        >
          <UserForm
            data={data}
            mode="create"
            setData={setData}
            errors={errors}
            avatarUrl={user.avatar_url ?? null}
            accounts={accounts}
          />
        </RecordForm>
      </div>
    </AdminLayout>
  )
}
